import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { FilterBar } from "./FilterBar";
import type { IconName } from "./icon/Icon";
import { Icon } from "./icon/Icon";
import { Button } from "./ui";

const NAV: Array<{ to: string; label: string; icon: IconName }> = [
  { to: "/", label: "개요", icon: "home" },
  { to: "/timeseries", label: "시계열", icon: "thunder" },
  { to: "/breakdown", label: "브레이크다운", icon: "template" },
  { to: "/logs", label: "로그 탐색기", icon: "documentText" },
  { to: "/admin", label: "관리", icon: "lock" },
];

/** The management page has its own concerns — the usage filter bar is noise there. */
const FILTERED_ROUTES = new Set(["/", "/timeseries", "/breakdown", "/logs"]);

export function Layout() {
  const { signOut } = useAuth();
  // useLocation, not window.location — the latter doesn't re-render on a
  // client-side navigation, so the bar would stick to whatever loaded first.
  const showFilters = FILTERED_ROUTES.has(useLocation().pathname);

  return (
    <div className="min-h-dvh bg-background-alternative">
      <header className="border-b border-line-alternative bg-background-normal">
        <div className="flex flex-wrap items-center gap-3 px-4 py-3 md:px-6">
          <div className="flex items-center gap-2">
            <Icon name="sparkleFill" size={20} style={{ color: "var(--primary-normal)" }} />
            <span className="text-body-1 font-bold text-label-strong">llm-logger</span>
            <span className="text-caption-1 text-label-assistive">LLM 사용 텔레메트리</span>
          </div>

          <nav className="flex flex-wrap items-center gap-1" aria-label="주요 화면">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  [
                    "inline-flex items-center gap-1.5 rounded-sm px-3 py-1.5 text-label-1 font-semibold transition-colors",
                    isActive
                      ? "bg-fill-normal text-primary"
                      : "text-label-alternative hover:bg-fill-alternative hover:text-label-normal",
                  ].join(" ")
                }
              >
                <Icon name={item.icon} size={16} />
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto">
            <Button size="small" variant="text" color="assistive" iconLeft="lockOpen" onClick={signOut}>
              로그아웃
            </Button>
          </div>
        </div>
      </header>

      {showFilters && <FilterBar />}

      <main className="mx-auto w-full max-w-[1400px] px-4 py-6 md:px-6">
        <Outlet />
      </main>
    </div>
  );
}
